import contract from '@mailobj-browser/front/js/contracts/contract.js'
import send from './send/send.js'
import mailbox from './mailbox/mailbox.js'
import filter from './filter/filter.js'
import templates from './templates/templates.js'
import antispam_bl from './antispam_bl/antispam_bl.js'
import signatures from './signatures/signatures.js'
import mailboxes from './mailboxes/mailboxes.js'
import antispam_wl from './antispam_wl/antispam_wl.js'
import search from './search/search.js'
import message from './message/message.js'

export default contract({
  antispam_bl,
  antispam_wl,
  filter,
  mailbox,
  mailboxes,
  message,
  search,
  send,
  signatures,
  templates,
})
